import { Component, OnInit } from '@angular/core';
import { AppService } from 'src/app/services/app-service.service';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss']
})
export class AboutComponent implements OnInit {

  founderObj:any = {};
  aboutObj:any = {};
  skillsObj:any = {};
  benefitsObj:any = {};
  experienceObj:any = {};
  contactObj:any = {};
  constructor(private appService:AppService) { }

  ngOnInit(): void {
    this.founderObj = this.appService.getPageByKey('founder');
    this.aboutObj = this.appService.getPageByKey('about');
    this.skillsObj = this.appService.getPageByKey('skills');
    this.benefitsObj = this.appService.getPageByKey('benefits');
    this.experienceObj = this.appService.getPageByKey('experience');
    this.contactObj = this.appService.getPageByKey('contact-me');

  }

}
